import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import InlineLogo from '../../assets/logo.inline.svg';

const Holder = styled.span`
  svg {
    width: 10rem;
    height: auto;
    display: block;
    path { fill: ${props => props.light ? props.theme.colours.white : props.theme.colours.black} }
    @media(${props => props.theme.breakpoints.md}) {
      width: 14rem;
    }
  }
`;

function Logo({light}) {
    return (
      <Holder light={light}>
        <InlineLogo />
      </Holder>
    )
}

Logo.propTypes = {
  light: PropTypes.bool
};

Logo.defaultProps = {
  light: false
};

export default Logo;
